export default __webpack_public_path__ + "static/media/dusk.a51ab448.jpg";